import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';

import { Button, Paragraph } from '@treams/treams-ui';

interface IProps {
	title: string;
	buttonTitle?: string;
	contentMarginTop?: number;
	contentMarginBottom?: number;
	icon?: ReactNode;
	to?: string;
	onClick?: () => void;
}

export default function ThankYouModal({
	title,
	buttonTitle,
	contentMarginTop = 2,
	contentMarginBottom = 2,
	icon,
	to,
	onClick,
}: IProps) {
	return (
		<Flex alignItems="center" flexDirection="column">
			<Box mt={contentMarginTop} mb={contentMarginBottom}>
				{icon}
			</Box>
			<Box p={3} textAlign="center">
				<Paragraph>{title}</Paragraph>
			</Box>

			{buttonTitle && (
				<Box py={2}>
					<Button link={to!} title={buttonTitle} onClick={onClick} />
				</Box>
			)}
		</Flex>
	);
}
